export default "__VITE_ASSET__BfJGZO2M__"